import React from "react";
import "./logo.css";
import logoNew from "../../assets/assets/images/logo-new.png";

const Logo = (props) => {
  const { style, className } = props;
  return (
    <div className={className ? "logo " + className : "logo"}>
      <img
        style={style}
        className="logo__image"
        src={logoNew}
        alt="ibank logo"
      />
    </div>
  );
};

export default Logo;
